<template>
    <div :id="page_slug">

        <div class="crumbs-bar">
            <el-row>
                <el-col :span="12">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ name: 'TemplateCategoryAdd' }">Template Category Add</el-breadcrumb-item>
                    <el-breadcrumb-item>Add</el-breadcrumb-item>
                </el-breadcrumb>        
                </el-col>      
            </el-row>
        </div>

        <el-form
            ref="template_category"
            :rules="rules.template_category"
            :model="template_category"
            :label-position="label_position">

            <el-form-item label="Name" prop="name">
                <el-input v-model="template_category.name"></el-input>
            </el-form-item>

            <el-form-item label="Sort Order" prop="sort_order">
                <el-input-number :min="0" v-model="template_category.sort_order"></el-input-number>
            </el-form-item>

            <el-form-item label="Hide" prop="is_hidden">
                <el-switch
                    v-model="template_category.is_hidden"
                    :active-value="1"
                    :inactive-value="0">
                </el-switch>
            </el-form-item> 

            <el-form-item>
                <el-button type="primary" @click="addTemplateCategory('template_category')">Add</el-button>
            </el-form-item>

        </el-form>

        <pre v-if="config.debug">{{$data}}</pre>

    </div>
</template>

<style>

</style>

<script>
    import Config from '@/store/Config.js';
    import Utils from '@/components/utils/Utils.js';
    import Auth from '@/components/auth/AuthCheck.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Add Template Category',
                page_slug: 'add-template-category',
                label_position: 'top',
                loading: false,
                rules: {
                    template_category: {
                        name: [
                            {required: true, message: 'Please Enter Corporation Name', trigger: 'blur'}
                        ],
                        sort_order: [
                            {required: true, message: 'Please Select Sort Order', trigger: 'blur'}
                        ],
                        is_hidden: [
                            {required: true, message: 'Please Select Sort Order', trigger: 'blur'}
                        ],
                    }
                },

                template_category: {
                    name: '',
                    sort_order: '',
                    is_hidden: '',
                    created_user_id: '',
                    updated_user_id: ''
                },
            };  
        },

        mounted: function() {
            const me = this;
        },

        methods: {
            addTemplateCategory: function(formName) {
                console.log('Add Template Category Function');
                const me = this;
                
                me.$refs[formName].validate((valid) => {
                if (valid) {
                    var jwt = Utils.decodejwt();
                    me.template_category.updated_user_id = jwt.sub;
                    me.template_category.created_user_id = jwt.sub;
                    me.$http.post(me.config.api + 'templateCategory', me.template_category).then(
                        response => {
                        console.log('Success posting data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        me.$notify({
                            title: 'Success',
                            message: 'The Template Category Was Added',
                            type: 'success'
                        });
                        me.resetForm('template_category');
                        me.$router.push({ name: 'TemplateCategoryList'});
                        }, response => {
                            console.log('Error posting data');
                            console.log(response.status);
                            console.log(response.statusText);
                        }
                    );
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });
            },

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/template-categories/TemplateCategoryAdd.vue